<div class="FormsTotemEnvironment">
    @if (isLoading || isSaving) {
        <app-pg-loading [isOverlay]="isSaving"></app-pg-loading>
    }
    @if (!isLoading) {
        @if (viewOnly) {
            <div>
                <app-pg-detail [formLayout]="formLayout" [hideEmpty]="true" [currentLanguage]="true"></app-pg-detail>
            </div>
        }
        @if (!viewOnly) {
            <div>
                <div class="text-end">
                    <button type="button" class="btn btn{{ showJSON ? '' : '-outline'}}-primary" (click)="toggleShowJSON()"
                        [attr.aria-pressed]="showJSON"
                        [attr.aria-label]="'forms-main.a11y.toggle-json' | locTranslate">
                        <i class="fa fa-code" aria-hidden="true"></i>
                    </button>
                </div>
                <app-pg-form #formComponent [formLayout]="formLayout" [languages]="availableLanguages" [hasSubmit]="false" [hideAdvanced]="true" (advancedModeChange)="onAdvancedModeChange($event)" (valueChange)="onValueChange($event)"></app-pg-form>
            </div>
        }

        @if(showJSON) {
            <div style="overflow: auto; max-height: 480px;">
                <app-pg-json-editor [(ngModel)]="JSONData"></app-pg-json-editor>
            </div>
        }

        <div [hidden]="showJSON" class="FormsTotemEnvironment-WidgetEditor"> <!-- TODO: andrebbe messa una versione in visualizzazione se è viewOnly-->
                <div class="border-bottom pb-3 d-flex justify-content-between align-items-center my-3">
                    <h5 class="m-0">Widget</h5>
                    <div class="d-flex">
                        <app-pg-select [required]="true" [(ngModel)]="addWidgetName" [options]="widgetOptions" display="oneLine"></app-pg-select>
                        <button type="button" class="btn btn-primary ms-2" [disabled]="addWidgetName == null" (click)="addWidget(addWidgetName); addWidgetName = null;"
                            [attr.aria-label]="'forms-main.a11y.add-item' | locTranslate">
                            <i class="fa-regular fa-plus" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
                <div class="row">
                    @for (widget of widgetList; track widget; let i = $index) {
                        <div class="FormsTotemEnvironment-WidgetEditor-Item pb-3 col-12">
                            <div class="card">
                                <div class="card-body pt-2 pb-3">
                                    <div class="d-flex justify-content-between align-items-center border-bottom pb-1 mb-2">
                                        <div>
                                            <h5 class="m-0">
                                                <span>{{widget.getLabel()}}</span>

                                                @if(widget.title) {
                                                    <span class="ms-3 text-muted">{{ getTranslatedValue(widget.title) }}</span>
                                                }
                                            </h5>
                                        </div>
                                        <div class="FormsTotemEnvironment-WidgetEditor-Item-Buttons d-flex align-items-center">
                                            <span class="font-monospace me-2">{{widget.id}}</span>
                                            
                                            <button type="button" class="btn btn-{{ widgetExpanded[widget.id] ? 'primary' : 'link' }}" (click)="widgetExpanded[widget.id] = !widgetExpanded[widget.id]"
                                                [attr.aria-expanded]="!!widgetExpanded[widget.id]"
                                                [attr.aria-label]="(widgetExpanded[widget.id] ? 'forms-main.a11y.collapse' : 'forms-main.a11y.expand') | locTranslate">
                                                <i class="fa-regular fa-{{ widgetExpanded[widget.id] ? 'compress' : 'expand' }}" aria-hidden="true"></i>
                                            </button>

                                            <button type="button" class="btn btn-link" [disabled]="viewOnly || i <= 0" (click)="moveWidget(i, -1)"
                                                [attr.aria-label]="'forms-main.a11y.move-up' | locTranslate">
                                                <i class="fa-regular fa-chevron-up" aria-hidden="true"></i>
                                            </button>

                                            <span class="FormsTotemEnvironment-WidgetEditor-Item-Buttons-Position">
                                                {{i + 1}}
                                            </span>

                                            <button type="button" class="btn btn-link" [disabled]="viewOnly || i >= widgetList.length - 1" (click)="moveWidget(i, 1)"
                                                [attr.aria-label]="'forms-main.a11y.move-down' | locTranslate">
                                                <i class="fa-regular fa-chevron-down" aria-hidden="true"></i>
                                            </button>
        
                                            <app-pg-confirm-action [disabled]="viewOnly" (confirmed)="deleteWidget(i)">
                                                <button type="button" class="btn btn-sm btn-link {{ viewOnly ? 'text-muted' : 'text-danger' }}" [disabled]="viewOnly"
                                                    [attr.aria-label]="'forms-main.a11y.delete-item' | locTranslate">
                                                    <i class="fa-regular fa-trash" aria-hidden="true"></i>
                                                </button>
                                            </app-pg-confirm-action>
                                        </div>
                                    </div>
                                    @if(widgetExpanded[widget.id]) {
                                        <app-pg-totem-widget-editor [values]="widget" (valuesChange)="onWidgetEditorValuesChange()" [viewOnly]="viewOnly"></app-pg-totem-widget-editor>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
    }
</div>